import * as React from "react";
import { ContentsHeader } from "@graffer-inc/console-design-kit";
import { ProceduresSearchWindow } from "../../../organisms/smart-apply/procedure-list/procedures-search-window";

type ArchivedProceduresListHeaderProps = {
  searchName: string;
  setSearchName: (name: string) => void;
  searchArchivedProcedures: (name: string) => void;
};

export const ArchivedProceduresListHeader: React.FC<
  ArchivedProceduresListHeaderProps
> = ({ searchName, setSearchName, searchArchivedProcedures }) => {
  return (
    <ContentsHeader
      title="アーカイブ一覧"
      border={false}
      caption={[
        <ProceduresSearchWindow
          key={"archivedProceduresSearchWindow"}
          searchName={searchName}
          setSearchName={setSearchName}
          searchProcedures={searchArchivedProcedures}
        />,
      ]}
    />
  );
};
